import { useEffect, useRef } from 'react';
import {
  createHeartbeat,
  grantedPosition,
  reportDevice,
  type DeviceReport,
} from '@ecobox/firebase';
import { useDriverData } from '../hooks/useDriver';
import { APP_VERSION } from '../env';
import { useBranch, useServices, useSession } from '../services';

/**
 * Tells the server this phone is alive (04 §4.6): when the app opens, every few minutes while it is
 * open and online, and after each sync. A driver with a run in progress also sends where the van
 * is, at most every two minutes, and only if location is already allowed.
 */
export function DeviceHeartbeat() {
  const services = useServices();
  const session = useSession();
  const { hasActiveRun } = useDriverData();
  const branch = useBranch().current;
  const active = useRef(hasActiveRun);
  const canReport = useRef(session.isStaff);
  const branchRef = useRef(branch);
  useEffect(() => {
    active.current = hasActiveRun;
    canReport.current = session.isStaff;
    branchRef.current = branch;
  });

  useEffect(() => {
    const beat = createHeartbeat({
      deviceId: services.deviceId,
      appVersion: APP_VERSION,
      connectivity: services.connectivity,
      sync: services.sync,
      send: (report: DeviceReport) => reportDevice(services.client.functions, report),
      canReport: () => canReport.current,
      getBranchId: () => branchRef.current,
      onActiveRun: () => active.current,
      getGeo: () => grantedPosition(),
    });
    return beat.start();
  }, [services]);

  return null;
}
